import styled from 'styled-components'

import { Box } from '@redriverpress/system'

const GenreImage = styled(Box).attrs({
  mr: [3, null, 2, 3],
  size: ['2rem', null, null, '3rem'],
  borderRadius: 'circular',
  flexShrink: 0,
})`
  background-image: url(${props => props.src});
  background-size: cover;
`

GenreImage.displayName = 'GenreImage'

export default GenreImage
